import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { DataService } from '@app-core/services/data/data.service';
import { DurationRangeService } from '@app-core/services/duration-range/duration-range.service';
import { AbbreviateNumberPipe } from '@app-shared/pipes/abbreviate-number/abbreviate-number.pipe';
import { DistancePipe } from '@app-shared/pipes/distance/distance.pipe';
import { CLIENT_CONFIG } from '@config/config';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * Analytics page Fleet snapshot component
 */
@Component({
  selector: 'app-fleet-stats',
  templateUrl: './fleet-stats.component.html',
  styleUrls: ['./fleet-stats.component.scss'],
  providers: [DistancePipe, AbbreviateNumberPipe],
})
export class FleetStatsComponent implements OnInit, OnDestroy {
  @Input()
  public fleetStats;
  @Input()
  public loader = true;
  public currentMetricUnit = null;
  public clientConfig = CLIENT_CONFIG;
  private destroy$ = new Subject<void>();

  constructor(private dataService: DataService, public durationService: DurationRangeService) {}

  public ngOnInit() {
    this.dataService._currentMetricUnit.pipe(takeUntil(this.destroy$)).subscribe((value: string) => {
      if (value) {
        this.currentMetricUnit = value;
      }
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
